import { useEffect } from 'preact/hooks';

export default function PastSearches({ filters, setFilters }) {
	const storageName = 'pastSearches';

	const stored = JSON.parse(localStorage.getItem(storageName));

	useEffect(() => {
		if (
			hasItems(filters.types) ||
			hasItems(filters.industryTerms) ||
			hasItems(filters.specieTerms) ||
			hasItems(filters.countyTerms)
		) {
			if (stored?.length >= 1) {
				if (stored?.length === 5) {
					const storedWithLastRemoved = stored.slice(0, -1);
					localStorage.setItem(
						storageName,
						JSON.stringify([filters].concat(storedWithLastRemoved))
					);
				} else {
					localStorage.setItem(
						storageName,
						JSON.stringify([filters].concat(stored))
					);
				}
			} else {
				localStorage.setItem(storageName, JSON.stringify([filters]));
			}
		}
	}, [filters]);

	function extractNames(array) {
		return array.map(i => i.name).join(', ');
	}

	function hasItems(array) {
		return array?.length >= 1;
	}

	const originalFilters = {
		ordering: 'DATE-DESC',
		industryTerms: [],
		specieTerms: [],
		countyTerms: [],
		types: [],
		favorites: null
	};

	return (
		stored && (
			<div>
				<p class="font-display font-bold mb-2 text-sm">Siste søk</p>

				<label class="relative block">
					<select
						class="appearance-none w-full text-base bg-light-gray border-2 border-light-gray rounded-lg h-11 pl-3.5 pr-11 hover:bg-gray hover:border-gray focus:outline-none focus:border-gray cursor-pointer"
						onChange={e => {
							setFilters(JSON.parse(e.target.value));
						}}
					>
						<option value={JSON.stringify(originalFilters)}>
							Siste søk
						</option>
						{stored.map(search => {
							const types = extractNames(search.types);
							const industries = extractNames(
								search.industryTerms
							);
							const species = extractNames(search.specieTerms);
							const counties = extractNames(search.countyTerms);

							let nameString = '';
							if (types) {
								nameString += types;
							}
							if (industries) {
								if (nameString !== '') {
									nameString += ' + ';
								}
								nameString += industries;
							}
							if (species) {
								if (nameString !== '') {
									nameString += ' + ';
								}
								nameString += species;
							}
							if (counties) {
								if (nameString !== '') {
									nameString += ' + ';
								}
								nameString += counties;
							}

							return (
								<option value={JSON.stringify(search)}>
									{nameString}
								</option>
							);
						})}
					</select>
					<i class="far fa-chevron-down absolute top-1/2 right-4 transform -translate-y-1/2 pointer-events-none"></i>
				</label>
			</div>
		)
	);
}
